import { createAppTheme } from '@hwm/ui-lib';
import { styleConstants } from './constants';

const theme = createAppTheme(styleConstants);

export default theme;
